<template>
  <div>
    <!--FROM - SENDING ACCOUNT-->
    <v-text-field
      v-model.sync="modelFrom"
      :disabled="!isSettingsEnabled"
      label="Sending Email Account"
      class="mw-400"
      hide-details
    >
    </v-text-field>

    <!--CLIENT ID-->
    <v-text-field
      v-model.sync="modelClientIdProtocol"
      :disabled="!isSettingsEnabled"
      label="Client ID"
      class="mw-400"
      hide-details
    >
    </v-text-field>

    <!--TENANT ID-->
    <v-text-field
      v-model.sync="modelTeanantId"
      :disabled="!isSettingsEnabled"
      label="Tenant ID"
      class="mw-400"
      hide-details
    >
    </v-text-field>

    <!--SECRET-->
    <v-text-field
      v-model.sync="modelSecret"
      :disabled="!isSettingsEnabled"
      :type="isShowSecret ? 'text' : 'password'"
      autocomplete="new-password"
      class="mw-400"
      label="Secret Key"
    >
      <template v-slot:append>
        <v-icon
          @mousedown="isShowSecret = true"
          @mouseup="isShowSecret = false"
          class="pointer"
          >mdi-eye{{ isShowSecret ? '-off' : '' }}</v-icon
        >
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'MsGraph',
  data() {
    return {
      isShowSecret: false,
    }
  },
  props: {
    organization: Object,
    isSettingsEnabled: Boolean,
    backupType: Number,
  },
  computed: {
    modelClientIdProtocol: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.msGraphDefinitions.clientId
          case 1:
            return this.organization.backupEmailDefinitions.msGraphDefinitions
              .clientId
          case 2:
            return this.organization.secondBackupEmailDefinitions.msGraphDefinitions
              .clientId
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return (this.organization.emailDefinitions.msGraphDefinitions.clientId =
              n)
          case 1:
            return (this.organization.backupEmailDefinitions.msGraphDefinitions.clientId =
              n)
          case 2:
            return (this.organization.secondBackupEmailDefinitions.msGraphDefinitions.clientId =
              n)
        }
      },
    },

    modelTeanantId: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.msGraphDefinitions.tenantId
          case 1:
            return this.organization.backupEmailDefinitions.msGraphDefinitions
              .tenantId
          case 2:
            return this.organization.secondBackupEmailDefinitions.msGraphDefinitions
              .tenantId
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return (this.organization.emailDefinitions.msGraphDefinitions.tenantId =
              n)
          case 1:
            return (this.organization.backupEmailDefinitions.msGraphDefinitions.tenantId =
              n)
          case 2:
            return (this.organization.secondBackupEmailDefinitions.msGraphDefinitions.tenantId =
              n)
        }
      },
    },

    modelSecret: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.msGraphDefinitions.clientSecret
          case 1:
            return this.organization.backupEmailDefinitions.msGraphDefinitions
              .clientSecret
          case 2:
            return this.organization.secondBackupEmailDefinitions.msGraphDefinitions
              .clientSecret
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return (this.organization.emailDefinitions.msGraphDefinitions.clientSecret =
              n)
          case 1:
            return (this.organization.backupEmailDefinitions.msGraphDefinitions.clientSecret =
              n)
          case 2:
            return (this.organization.secondBackupEmailDefinitions.msGraphDefinitions.clientSecret =
              n)
        }
      },
    },

    modelFrom: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.msGraphDefinitions.senderEmail
          case 1:
            return this.organization.backupEmailDefinitions.msGraphDefinitions
              .senderEmail
          case 2:
            return this.organization.secondBackupEmailDefinitions.msGraphDefinitions
              .senderEmail
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return (this.organization.emailDefinitions.msGraphDefinitions.senderEmail =
              n)
          case 1:
            return (this.organization.backupEmailDefinitions.msGraphDefinitions.senderEmail =
              n)
          case 2:
            return (this.organization.secondBackupEmailDefinitions.msGraphDefinitions.senderEmail =
              n)
        }
      },
    },
  },
}
</script>
